import find from 'lodash/find';
import get from 'lodash/get';

export default (sitecoreContext, componentName) => {
  const components = get(
    sitecoreContext,
    'route.placeholders["jss-main"]',
    false,
  );

  if (!components) {
    return false;
  }

  return find(
    components,
    component => component.componentName === componentName,
  );
};
